import { ModelBase } from 'store/model-base';

export class LineRetention extends ModelBase {
    public static storeName: string = 'lineRetention';

    public cards: IcopCardContents[];

    public static create<T extends ModelBase>(initData: ApiResponse): T {
        const toReturn: LineRetention = super.create<LineRetention>(initData);

        /* eslint-disable @typescript-eslint/no-explicit-any */
        return <T> <any> toReturn;
        /* eslint-enable @typescript-eslint/no-explicit-any */
    }
}
